import React, { createContext, useContext, ReactNode } from 'react';
import { useSubscription, UseSubscriptionResults } from '../hooks/use-subscription';

export const SubscriptionContext = createContext<UseSubscriptionResults | undefined>(undefined);

export interface SubscriptionProviderProps {
  children: ReactNode;
}

export const SubscriptionProvider: React.FC<SubscriptionProviderProps> = ({ children }) => {
  const subscription = useSubscription();

  return (
    <SubscriptionContext.Provider value={subscription}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscriptionContext = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscriptionContext must be used within a SubscriptionProvider');
  }
  return context;
};